<template>
    <ui-modal icon="far fa-laptop-code" name="instructions-api" title="Integração para Desenvolvedores" size="sm">
        <section class="modal-content-line">
            <p>Caso seja necessário enviar leads para o Facilita em aplicações no qual a utilização do nosso script não seja possível, o desenvolvedor poderá utilizar as seguintes informações para este objetivo.</p>
        </section>
        <section class="modal-content-line">
            <h2>URL e Método:</h2>
            <ul class="list-default">
                <li>Método: POST</li>
                <li>URL: https://{{instance}}.api.facilitavendas.com/public/trackerform</li>
            </ul>
        </section>
        <section class="modal-content-line">
            <h2>Envio dos campos obrigatórios:</h2>
            <ul class="list-default">
                <li>facilita_custom_page: Título da página</li>
                <li>facilita_custom_url: http://www.urldapagina.com.br</li>
                <li>facilita_custom_selector: idformulario</li>
            </ul>
        </section>
        <section class="modal-content-line">
            <h2>Envio dos campos com informações do Lead:</h2>
            <ul class="list-default">
                <li>name</li>
                <li>email</li>
                <li>phone</li>
                <li>mobile</li>
                <li>cpf</li>
                <li>obs</li>
                <li>message</li>
            </ul>
        </section>
        <section class="modal-content-line">
            <h2>Considerações:</h2>
            <p>O id do formulário (facilita_custom_selector) não pode ser alterado, caso contrário será necessário configurar novamente o mapeamento dos campos.</p>
        </section>
    </ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'   
    import { storage } from '@/services/storage'
	
	export default {
		components: { uiModal },
		data(){
			return {
                instance: null,
			}
        },
        computed: {
            scriptComputed: {
                get() {
                    /** Deve-se dividir a string da tag script para que não dê o erro "String literal" */
                    return "<scr" + "ipt type='text/javascript'>(function(){function loadScript(url,callback){var script=document.createElement('script');script.type='text/javascript',script.readyState?script.onreadystatechange=function(){(script.readyState=='loaded'||script.readyState=='complete')&&(script.onreadystatechange=null,callback());}:script.onload=function(){callback();},script.src=url,document.getElementsByTagName('head')[0].appendChild(script);}loadScript('https://cdn.appfacilita.com/static/plugins/jquery.form-tracker.min.js?v=1.5',function(){facilitaFormTrackerFnc({i:'" + this.instance + "'});});}());</scr" + "ipt>"
                }
            }
        },
		methods: {
			
        },
        created(){
            let api_config = storage.get('api_config');
            api_config = JSON.parse(api_config)
            this.instance = api_config.instance
            
        }
	}
</script>